import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import classNames from 'classnames';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { CampaignState, getCampaignDetailsById } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
const PREFIX = 'PaymentStatusDialogBox';

const classes = {
    table: `${PREFIX}-table`
};

const Root = styled('div')({
	[`& .${classes.table}`]: {
		minWidth: 'auto',
	},
});

const PaymentStatusDialogBox = (props: any) => {

	const dispatch = useAppDispatch();
	const [open, setOpen] = React.useState(false);
	const rowData = props.rowData;
	const campaignStore: CampaignState = useAppSelector(
		(state: RootState) => state.campaign,
	);
	const { campaign } = campaignStore;
	const handleClickOpen = () => {
		setOpen(true);
		dispatch(getCampaignDetailsById(rowData.id));
	};

	const handleClose = () => {
		setOpen(false);
	};

	const rows = campaign.campaignPaymentDetailsResponse;

	const transformStatusToCSSClass = (status: any) => {
		return status.replace(/\s/g, '').toLowerCase();
	};
	return (
        <Root style={{ width: '700px' }}>
			<Button
				variant="outlined"
				color="primary"
				onClick={handleClickOpen}
				className={classNames(
					'campaign-status',
					'status-' + transformStatusToCSSClass(rowData.paymentStatus),
				)}>
				{rowData.paymentStatus}
			</Button>
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Payment Status</DialogTitle>
				<DialogContent>
					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell>Payment Method</TableCell>
									<TableCell align="center">Payment Option</TableCell>
									<TableCell align="center">Amount</TableCell>
									<TableCell align="center">Status</TableCell>
									<TableCell align="center">Comments</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows?.map((row: any) => (
									<TableRow key={row}>
										<TableCell component="th" scope="row">
											{row.paymentMethod}
										</TableCell>
										<TableCell align="center">
											{row.paymentOption}
										</TableCell>
										<TableCell align="center">
											{row.paymentAmount}
										</TableCell>
										<TableCell align="center">{row.status}</TableCell>
										<TableCell align="center">
											{row.campaignPaymentStatusLogList.length > 0
												? row.campaignPaymentStatusLogList[0]
														.comments
												: 'No comments available'}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						close
					</Button>
				</DialogActions>
			</Dialog>
		</Root>
    );
};

export default PaymentStatusDialogBox;
